<div
  class="stream_container"
  [ngClass]="{ 
    'stream_container--single': isSingleImage,
    'stream_container--minimized': !!minimized,
    'stream_container--full': !!full,
    'stream_container--upper': isUpper
   }">
  <div class="stream_panel">
    @if (!streamPending) {
      @if (!minimized) {
        <span (click)="onFullToggle()" class="stream_full-icon">
          @if (!full) {
            <i
              class="fas fa-expand-arrows-alt"
              matTooltip="{{ 'fullScreen' | translate | titlecase }}">
            </i>
          } @else {
            <i class="fas fa-compress-arrows-alt" matTooltip="{{ 'exitFullScreen' | translate | titlecase }}"></i>
          }
        </span>
      }
      @if (!full) {
        <span (click)="onMinimizeToggle()">
          @if (!minimized) {
            <i
              class="far fa-window-minimize"
              matTooltip="{{ 'minimize' | translate | titlecase }}">
            </i>
          } @else {
            <i class="far fa-window-maximize" matTooltip="{{ 'maximize' | translate | titlecase }}"></i>
          }
        </span>
      }
    }
    <span
      (click)="onClose()"
      matTooltip="{{ 'stopStreaming' | translate | titlecase }}">
      <i class="fas fa-times"></i>
    </span>
  </div>

  @if (streamPending) {
    <div class="stream_message">
      <div>
        <div>
          {{ 'streamStarting' | translate }}
        </div>
        <app-load
          [isLight]="true"
          class="text--xxs">
        </app-load>
      </div>
    </div>
  }

  @if (!isV2Streaming) {
    <img #leftImage [ngClass]="{ 'hidden': streamPending }">
    <img #rightImage [ngClass]="{ 'hidden': streamPending }">
  }

  @if (isV2Streaming) {
    <div
      id="stream_v2_content"
      class="stream_content"
      [ngClass]="{ 'hidden': streamPending }">
      @if (isConnectionFail && !minimized) {
        <span class="stream_notification">
          {{'deviceConnectionFailed' | translate}}
        </span>
      }
    </div>
  }
</div>


